import Image1 from '../../assets/images/lists_products/1.jpeg'
import Image2 from '../../assets/images/lists_products/2.jpeg'
import Image3 from '../../assets/images/lists_products/3.jpeg'
import Image4 from '../../assets/images/lists_products/4.jpeg'
import Image5 from '../../assets/images/lists_products/5.jpeg'
import Image6 from '../../assets/images/lists_products/6.jpeg'
import Image7 from '../../assets/images/lists_products/7.jpeg'
import Image8 from '../../assets/images/lists_products/8.jpeg'
import Image9 from '../../assets/images/lists_products/9.jpeg'
import Image10 from '../../assets/images/lists_products/10.jpeg'
import Image11 from '../../assets/images/lists_products/11.jpeg'
import Image12 from '../../assets/images/lists_products/12.jpeg'
import Image13 from '../../assets/images/lists_products/13.jpeg'
import Image14 from '../../assets/images/lists_products/14.jpeg'
import Image15 from '../../assets/images/lists_products/15.jpeg'
import Image16 from '../../assets/images/lists_products/16.jpeg'
import Image17 from '../../assets/images/lists_products/17.jpeg'
import Image18 from '../../assets/images/lists_products/18.jpeg'
import Image19 from '../../assets/images/lists_products/19.jpeg'
import Image20 from '../../assets/images/lists_products/20.jpeg'

export const ListProductsData = [
    { 
        img: Image1,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (GREEN TEA)'
    },
    { 
        img: Image2,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (MISTY BLUE)'
    },
    { 
        img: Image3,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (DUSTY PINK)'
    },
    { 
        img: Image4,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (BLACK)'
    },
    { 
        img: Image5,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (BURGUNDY)'
    },
    { 
        img: Image6,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (FUSCIA)'
    },
    { 
        img: Image7,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (CHAMPAGNE)'
    },
    { 
        img: Image8,
        text: 'ALEENA PLEATED ABAYA FOR KIDS (NAVY BLUE)'
    },
    { 
        img: Image9,
        text: 'SAFAA ABAYA FOR KIDS (GREY)' 
    },
    { 
        img: Image10,
        text: 'SAFAA ABAYA FOR KIDS (GREEN TEA)' 
    },
    { 
        img: Image11,
        text: 'SAFAA ABAYA FOR KIDS (BROWN)' 
    },
    { 
        img: Image12,
        text: 'SAFAA ABAYA FOR KIDS (BLACK)'  
    },
    { 
        img: Image13,
        text: 'SAFAA ABAYA FOR KIDS (OFF WHITE)' 
    },
    { 
        img: Image14,
        text: 'SAFAA ABAYA FOR KIDS (BURGUNDY)' 
    },
    { 
        img: Image15,
        text: 'SAFAA ABAYA FOR KIDS (OLIVE GREEN)' 
    },
    { 
        img: Image16,
        text: 'AMINA PLEATED ABAYA (MINT GREEN)' 
    },
    { 
        img: Image17,
        text: 'AMINA PLEATED ABAYA (DUSTY PINK)' 
    },
    { 
        img: Image18,
        text: 'AMINA PLEATED ABAYA (NAVY BLUE)' 
    },
    { 
        img: Image19,
        text: 'AMINA PLEATED ABAYA (BURGUNDY)' 
    },
    { 
        img: Image20,
        text: 'BILQIS ABAYA (BLACK)' 
    },
]